import { Link } from '@backstage/core-components';
import { Theme, makeStyles } from '@material-ui/core';

/**
 * Shared footer for Home cards: a plain "View more" text link (or the stock "View more" /
 * "View less" toggle of the visits cards) pinned to the bottom-right corner. Cards use
 * `variant="fullHeight"`, so the footer sits in the same spot on equal-height cards.
 */
export const useHomeCardFooterStyles = makeStyles((theme: Theme) => {
  const link = {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 600,
    lineHeight: 1.5,
    color: theme.palette.link ?? theme.palette.primary.main,
  };
  return {
    actions: {
      justifyContent: 'flex-end',
      marginTop: 'auto',
      padding: theme.spacing(1, 2, 1.5),
      // plugin-home's "View more" toggle (Recently / Top Visited) is a Button; make it read as the same link.
      '& .MuiButton-root': {
        ...link,
        minWidth: 0,
        padding: 0,
        textTransform: 'none',
        letterSpacing: 'normal',
        '&:hover': {
          backgroundColor: 'transparent',
          textDecoration: 'underline',
        },
      },
    },
    link,
  };
});

export interface ViewMoreLinkProps {
  to: string;
  label?: string;
}

/** "View more" text link for the bottom-right footer of a Home card (pass it as InfoCard `actions`). */
export const ViewMoreLink = ({ to, label = 'View more' }: ViewMoreLinkProps) => {
  const classes = useHomeCardFooterStyles();
  return (
    <Link to={to} underline="hover" className={classes.link}>
      {label}
    </Link>
  );
};